import axios from 'axios';
import BaseApi from './base-api';

class MeetingCategoriesApi extends BaseApi {
  getMeetingCategories() {
    return axios
      .get(`${this.baseUrl}/meeting_categories`)
      .then((response) => {
        return {
          ok: true,
          meetingCategories: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const meetingCategoriesApi = new MeetingCategoriesApi();
